import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { FeeProcessComponent } from '../fee-process/fee-process.component';
import { PayGatewayComponent } from '../pay-gateway/pay-gateway.component';
import { RazorpayPayComponent } from '../razorpay-pay/razorpay-pay.component';
import { UniSuitPayComponent } from '../uni-suit-pay/uni-suit-pay.component';

@Component({
  selector: 'app-payment-message',
  templateUrl: './payment-message.component.html',
  styleUrls: ['./payment-message.component.scss']
})
export class PaymentMessageComponent implements OnInit {

  constructor(private elRef: ElementRef, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,private cdr: ChangeDetectorRef,
    public router: Router,
    public umsService: UmsService,) { }
    
  ngOnInit(): void {
    // let the = localStorage.getItem('theme')
    // if(the.length <= 0){
    //   this.theme('blue')
    // }else{
    //   this.theme(the);
    // }
  }


  theme(i){
    if(i== 'white'){
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one','gray');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#aaaaaa');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color','gray');
      this.elRef.nativeElement.style.setProperty('--dark-border','gray');
      this.elRef.nativeElement.style.setProperty('--main-content-title','gray');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','black');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','black');
      this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
      localStorage.setItem("theme",i)
    }else if(i== 'yellow'){
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one','#ffab00');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#efb960');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color','#ffab00');
      this.elRef.nativeElement.style.setProperty('--dark-border','#ffab00');
      this.elRef.nativeElement.style.setProperty('--main-content-title','#ffab00');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','#ffb10f');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','#f0d6a1');
      this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
      localStorage.setItem("theme",i)
    }else if(i== 'red'){
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one','#ff4a42');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#ef8d89');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color','#ff4a42');
      this.elRef.nativeElement.style.setProperty('--dark-border','#ff4a42');
      this.elRef.nativeElement.style.setProperty('--main-content-title','#ff4a42');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','#ff4a42');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','#ff4a42');
      this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
      localStorage.setItem("theme",i)
    }else if(i== 'green'){
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one','green');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#85b87f');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color','green');
      this.elRef.nativeElement.style.setProperty('--dark-border','green');
      this.elRef.nativeElement.style.setProperty('--main-content-title','green');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','green');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','green');
      this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
      localStorage.setItem("theme",i)
    }else if(i == 'sky_blue'){
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one','#03a2e2');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#96d1f1'); 
      this.elRef.nativeElement.style.setProperty('--primary-bg-color','#03a2e2');
      this.elRef.nativeElement.style.setProperty('--dark-border','#03a2e2');
      this.elRef.nativeElement.style.setProperty('--main-content-title','#03a2e2');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','#03a2e2');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','#03a2e2');
      this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
      localStorage.setItem("theme",i)
    }else{
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one','#0c1d78');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#1b3ad4');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color','#0c1d78');
      this.elRef.nativeElement.style.setProperty('--dark-border','#0c1d78');
      this.elRef.nativeElement.style.setProperty('--main-content-title','#0c1d78');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','#7787bc');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','#8f9cc0');
      this.elRef.nativeElement.style.setProperty('--side-sub-link','#c7c7c7');
      localStorage.setItem("theme",i)
    }
   }

//    redirectGateway(){
//     this.cdr.detectChanges(); // Trigger change detection
//   const gatewayName = this.data.gateway['gatewayName'];
//     switch (gatewayName) {
//       case "Easebuzz":
//         this.umsService.setpayDetails(this.data);
//         this.redirect('easebuzz')
//         break;
//       case "HDFC Bank":
//         this.umsService.setpayDetails(this.data);
//         this.redirect('razorpay')
//         break;
//       default:
//         break;
//     }
//    }

redirectGateway() {
  // Force change detection manually
  this.cdr.markForCheck(); // Mark component for checking in the next cycle
  this.cdr.detectChanges(); // Trigger change detection
  const gatewayName = this.data.gateway['gatewayName'];
  switch (gatewayName) {
    case "Easebuzz":
      this.umsService.setpayDetails(this.data);
      this.redirect('easebuzz');
      break;
    case "HDFC Bank":
      this.umsService.setpayDetails(this.data);
      this.openRazorpayPopUp();
      break;
      case "Uni Suite":
        this.umsService.setpayDetails(this.data);
        this.openUniSuitGateway();
        break;
    default:
      break;
  }
}

  redirect(to): void {
    // for reload next click on same button
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([to]);  // Navigate to the same route
    });
  }

  closeAllDialogs() {
    this.dialog.closeAll();  // This will close all open dialogs
    this.router.navigate(['home']);
  }

  openRazorpayPopUp() {
    const dialogRef4 = this.dialog.open(RazorpayPayComponent,
     {
       disableClose: true,
       width: "600px",
       height: "auto",
       panelClass: 'custom-dialog-container'
     });
   dialogRef4.afterClosed().subscribe((result) => {
     
   });
 }

 openUniSuitGateway() {
  const dialogRef4 = this.dialog.open(UniSuitPayComponent,
   {
     disableClose: true,
     width: "600px",
     height: "auto",
     panelClass: 'custom-dialog-container'
   });
 dialogRef4.afterClosed().subscribe((result) => {
   
 });
}
}
